
import {BehaviorSubject,Observable,from } from 'rxjs';
import {map} from 'rxjs/operators';
import {
  IdsDTO,
  MasterlinkRoleServiceProxy,
  Role,
  RoleBriefDTO,
  RoleVO,
  R,
} from "@/service-proxies/app-v2/system.service-proxies";

export class RoleInfo{
  id?: string;
  name?:string;
}

function roleVoToRoleInfo(role:RoleVO):RoleInfo{
  const result:any={
    id:role.id,
    name:role.roleName
  }
  return result as RoleInfo;
}

export class RoleStoreService{

  private readonly _roleService: MasterlinkRoleServiceProxy;

  private _roleList$ = new BehaviorSubject<RoleInfo[]>([]);
  private _selectedRole$=new BehaviorSubject<RoleInfo>({});

  private store: {
    roleList: RoleInfo[],
    selectedRole: RoleInfo
  } = {
    roleList: [],
    selectedRole: {}
  };

  readonly roleList$ = this._roleList$.asObservable();
  readonly selectedRole$ = this._selectedRole$.asObservable();

  constructor() {
    this._roleService = new MasterlinkRoleServiceProxy();
  }

  selectRole(role: RoleInfo){
    this.store.selectedRole = role;
    this._selectedRole$.next(Object.assign({}, this.store).selectedRole);
  }


  findAllRoleList(){

    from(this._roleService.getRoles(undefined,undefined))
        .pipe(
          map(res=>res.data.roleVOList)
        )
        .subscribe((res:any)=>{
          const roleList:RoleInfo[] = res.map((c:any)=>roleVoToRoleInfo(c as RoleVO));
          this.store.roleList = roleList;
          this._roleList$.next(Object.assign({}, this.store).roleList);
          if(roleList.length>0){
            this.selectRole(roleList[0]);
          }
        });
  }


  saveRole(role:RoleInfo):Observable<boolean>{

    const submitRole = RoleBriefDTO.fromJS(role);
    submitRole.displayName = role.name;

    let submit:Observable<R> = null;
    if(role.id && role.id !=='0'){
      // 更新
      submit = from(this._roleService.update(role.id,submitRole));
    }else {
      submit = from(this._roleService.create(submitRole));
    }

    return submit
        .pipe(
          map(res=>{
            this.findAllRoleList();
            return true;
          }),
        );
  }

  deleteRole(roleId:string){
    return from(this._roleService.deleteRoles(new IdsDTO({idList: roleId.split(',')})))
            .pipe(
              map(res=>{
                this.findAllRoleList();
                return true;
              })
            );
  }

  clearRoleList(){
    this.store.roleList=[];
    this._roleList$.next(Object.assign({}, this.store).roleList);
  }

}


export function isSystemRole(roleName:string){
  const systemRoleList:string[]=[
    '超级管理员',
    '管理员',
    '人事',
    '经理',
    '老板',
    '用户'
  ];

  return systemRoleList.filter(c=>c===roleName).length>0;
}

const roleStoreService:RoleStoreService = new RoleStoreService();
export default roleStoreService;
